import { ANCHO_POPOVER_REPORTE, MAX_COMENTARIO } from "../constants/reportarProblema.constants";

export const limpiarComentario = (texto: string, maximo = MAX_COMENTARIO): string =>
    texto.slice(0, maximo);

export const esComentarioValido = (texto: string): boolean => texto.trim().length > 0;

export const textoContador = (texto: string, maximo = MAX_COMENTARIO): string =>
    `${texto.length}/${maximo}`;

export const esAtajoEnviar = (evento: React.KeyboardEvent): boolean =>
    evento.key === "Enter" && (evento.ctrlKey || evento.metaKey);